var map = {
	"./images/back.png": 547,
	"./images/book.png": 548,
	"./images/code.png": 549,
	"./images/forward.png": 550,
	"./images/name.png": 551,
	"./images/search.png": 552,
	"./images/student-border.png": 553
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 546;